import { defineComponent } from 'vue';
import CategoryTwelveComponent from '@/components/CategoryTwelve/CategoryTwelveComponent.vue';
export default defineComponent({
    name: 'CategoryTwelveDialog',
    props: {
        propSelected: Array
    },
    components: { CategoryTwelveComponent },
    data: function () {
        return {
            show: false
        };
    },
    methods: {
        refresh() {
            this.$emit('refresh');
        },
        showHideDialog() {
            this.show = !this.show;
        },
        createNew() {
            this.show = true;
        }
    }
});
